import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { catchError, throwError } from 'rxjs';
import { ToastService } from '../helpers/toast.service';
import { environment } from '@src/environments/environment';

const errorTitleKeys: Record<number, string> = {
  400: 'ERROR_TITLES.VALIDATION_ERROR',
  401: 'ERROR_TITLES.UNAUTHORIZED',
  403: 'ERROR_TITLES.ACCESS_DENIED',
  404: 'ERROR_TITLES.NOT_FOUND',
  409: 'ERROR_TITLES.CONFLICT',
  422: 'ERROR_TITLES.INVALID_DATA',
  500: 'ERROR_TITLES.INTERNAL_ERROR',
  502: 'ERROR_TITLES.SERVER_UNAVAILABLE',
  503: 'ERROR_TITLES.SERVICE_UNAVAILABLE',
};

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.includes('/assets/i18n/') || !req.url.startsWith(environment.apiUrl)) {
    return next(req);
  }

  const isLoginRequest = req.url.includes('/login/user-login');
  const _toast = inject(ToastService);
  const _translate = inject(TranslateService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const rawError = error.error;
      const errorCode =
        Array.isArray(rawError) && rawError.length > 0 && typeof rawError[0] === 'string'
          ? rawError[0]
          : typeof rawError === 'string' && rawError.trim().length > 0
            ? rawError
            : typeof rawError?.message === 'string' && rawError.message.trim().length > 0
              ? rawError.message
              : 'UNEXPECTED_ERROR';
      const titleKey = errorTitleKeys[error.status] ?? 'ERROR_TITLES.INTERNAL_ERROR';

      let message = _translate.instant(`ERROR_MESSAGES.${errorCode}`);

      if (error.status === 403) {
        const detail = _translate.instant('ERROR_MESSAGES.REQUEST_DETAIL', {
          method: req.method,
          url: error.url ?? req.url
        });
        message = `${message} ${detail}`;
      }

      _toast.showErrorToast(
        _translate.instant(titleKey),
        message,
        error.status >= 500
      );
      return throwError(() => error);
    }),
  );
};
